import { gql } from '@apollo/client';

import STUDENT_FRAGMENT from '../fragments/student';

const SEARCH_STUDENTS_QUERY = gql`
  query searchStudents(
    $searchText: String!
    $classroomIds: [Int!]
    $organizationIds: [Int!]
    $limit: Int
  ) {
    studentSearch(
      searchText: $searchText
      classroomId: $classroomIds
      organizationId: $organizationIds
      orderBy: { field: [LAST_NAME, FIRST_NAME, ID], direction: [ASC, ASC, DESC] }
      paging: { limit: $limit }
    ) {
      ...BaseStudent
    }
  }
  ${STUDENT_FRAGMENT}
`;

export default SEARCH_STUDENTS_QUERY;
